import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mask',
})
export class MaskPipe implements PipeTransform {
  transform(
    value: string,
    isMaskData: boolean = false,
    visibleChars: number = 3,
    maskChar: string = '*'
  ): string {
    if (!isMaskData) {
      return value;
    }

    if (/^[\d,.]+$/.test(value)) {
      return '0';
    }
    const pattern = new RegExp(`^(.{${visibleChars}})(.*)$`);
    return value.replace(pattern, (_, first, rest) => {
      return first + maskChar.repeat(rest.length);
    });
  }
}
